import { createStyles, makeStyles } from "@mui/styles"; 
import { Theme } from "@mui/material";

export const FooterStyles = makeStyles((theme: Theme) =>
  createStyles({
    footer: {
      flexShrink: 0,
      marginBottom: 70,
      padding: 10,
      display: "flex",
      alignItems: "center",
    },
    user: {
      marginLeft: "auto",
    },
  })
);
